import React from 'react';
import {
  Text,
  TextAppearance,
  TagOverrides,
  createTagOverride,
  Link,
  LinkProps,
  Richtext,
} from '@vw-marketing/us-components';
import {
  LabelTextWrapper,
  DescriptionWrapper,
  NoRecallWrapper,
  StyledStrong,
} from './styled';

interface NoRecallProps {
  messageLabel: string;
}

const NoRecallTemplate = {
  label: 'There are currently no %%LABEL%% listed for your vehicle.',
  description:
    'This system tracks  %%DESCRIPTION%% for which vehicles are subject to repair in the United States. The information provided is subject to change and update. There may be temporary delays in update of information on this site due to a number of factors. For the latest information regarding the status of your vehicle, or of any Volkswagen recall program, please contact your authorized Volkswagen dealer directly or [**Volkswagen Customer CARE**](/en/contact.html).',
};

const NoRecall = ({ messageLabel }: NoRecallProps): JSX.Element => {
  const label = NoRecallTemplate.label.replace('%%LABEL%%', messageLabel);
  const description = NoRecallTemplate.description.replace(
    '%%DESCRIPTION%%',
    messageLabel,
  );
  const tagOverrides: TagOverrides = {
    span: createTagOverride(Text, {
      appearance: TextAppearance.copy0200,
      // style: { lineHeight: TextLineHeight.TextLineHeight24 }
    }),
    strong: createTagOverride(StyledStrong),
    a: createTagOverride(Link, { isInline: true } as LinkProps),
  };
  return (
    <NoRecallWrapper>
      <LabelTextWrapper>
        <Text appearance={TextAppearance.headline0350}>{label}</Text>
      </LabelTextWrapper>
      <DescriptionWrapper>
        <Richtext markdown={description} overrides={tagOverrides} />
      </DescriptionWrapper>
    </NoRecallWrapper>
  );
};

export default NoRecall;
